import { c as _c } from "react/compiler-runtime";
import { Accordion, Text } from '@chakra-ui/react';
import { GenericBlock } from '@src/components/sco/LayoutBlocks/GenericBlock';
import React from 'react';
export const QuestionsBlock = () => {
  const $ = _c(5);
  let t0;
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      children: "Frequent Questions"
    };
    t1 = {
      maxWidth: "container.lg"
    };
    t2 = {
      children: "Want to know more? Here's some common questions & answers."
    };
    $[0] = t0;
    $[1] = t1;
    $[2] = t2;
  } else {
    t0 = $[0];
    t1 = $[1];
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = [];
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <GenericBlock headingProps={t0} innerBoxProps={t1} textProps={t2}><Accordion.Root multiple={true} defaultValue={t3} variant="plain" width="full">{[{
          question: "How do you actually match me with investors?",
          answer: "We take every active investor and rank all of them based on weighted factors such as your fundraise size, industry, stage, location, and details you provide about the startup.  Every investor has specific areas of focus, so we rank the most compatible ones first to significantly improve your outcomes."
        }, {
          question: "Will investors contact me?",
          answer: "Not unless you reach out first.  Our system is built so that you're initiating contact on your terms.  Great investors, like those on our platform, generally don't have to be the ones calling on startups - great startups like yours contact them instead."
        }, {
          question: "Do I need a pitch deck to get started?",
          answer: "You can do all of your research and build a list of investors to contact, but once you're ready to reach investors, you should definitely be prepared with a quality Pitch Deck. Not sure if yours is any good?  Ask us, we'll help you out."
        }, {
          question: "How does the automated outreach work?",
          answer: "We take all of the investors you've chosen to contact and create custom emails that you can write or use our AI to help craft.  Our system will then connect with your preferred email service (Gmail, Outlook, etc) and send the emails out on your behalf just as if you sent them yourself."
        }, {
          question: "Why would I want your system to email for me?",
          answer: "There are two major factors, and why we built the system. First, we don't mass-blast every investor at once. That pretty much guarantees you wind up in SPAM boxes or blocked altogether.  We send on a constant, natural pace for you.  Second, we customize each email so it comes across as professional and authentic, leading to significantly higher response rates."
        }, {
          question: "Will investors respond to my emails?",
          answer: "If you have a really good deal, then they likely will.  But if it's something no one is interested in, or it's poorly prepared or pitched, then probably not.  Investors get inundated with inbound requests (like Employers do for jobs) so they only respond to the deals they think are the best."
        }, {
          question: "How quickly will investors be contacted?",
          answer: "Within minutes of your send.  While we do make sure we don't blast all the investors at once to make sure you don't wind up immediately in SPAM filters, we also want to make sure we get your fundraise moving ASAP."
        }].map(_temp)}</Accordion.Root></GenericBlock>;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  return t4;
};
function _temp(item, index) {
  return <Accordion.Item key={index} bgColor="colorPalette.muted" border="1px solid transparent" borderRadius="lg" marginBottom={2} value={`q-${index}`} _hover={{
    borderColor: "colorPalette.border"
  }} _open={{
    borderColor: "colorPalette.border"
  }}><Accordion.ItemTrigger _expanded={{
      paddingBottom: 2
    }} padding={6}><Text color="colorPalette.fg" flex={1} fontSize="lg" fontWeight={600} textAlign="left">{item.question}</Text><Accordion.ItemIndicator /></Accordion.ItemTrigger><Accordion.ItemContent paddingBottom={6} paddingX={6}><Accordion.ItemBody><Text color="colorPalette.fg" fontSize="lg">{item.answer}</Text></Accordion.ItemBody></Accordion.ItemContent></Accordion.Item>;
}